module.exports = __webpack_public_path__ + "img/topimg.ae398c8d.svg";